import { ArrowRight } from "lucide-react";
import { Reveal, Chapter, SectionHeading } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

const LINKS = [
  ["Business", "Customer"],
  ["Team", "Team"],
  ["Contractor", "Supplier"],
  ["Project Owner", "Everyone"],
];

const INDUSTRIES = ["Construction", "Property", "Installation", "Maintenance", "Professional services", "Events", "Freelancers", "Small businesses"];

export const Business = () => (
  <section id="business" className="bg-diem-ink py-28 sm:py-36 relative overflow-hidden" data-testid="business-section">
    <div className="absolute inset-0 opacity-[0.15]" style={{ background: "radial-gradient(700px 400px at 85% 20%, #0055FF, transparent 65%)" }} />
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
      <Chapter index="10" label="For business" dark />
      <div className="mt-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal delay={0.1}>
            <SectionHeading dark>Built for real work.</SectionHeading>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-7 text-lg leading-relaxed text-white/60 max-w-lg">
              Your customers don't want another portal. Your team doesn't want another system.
              Everyone already knows how to message.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {INDUSTRIES.map((i) => (
                <span key={i} className="rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-white/60 hover:text-white hover:border-diem-sky/50 transition-colors duration-300 cursor-default">
                  {i}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.4}>
            <button
              data-testid="business-cta"
              onClick={() => scrollToId("#waitlist")}
              className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-diem-blue text-white font-semibold px-8 py-4 shadow-[0_12px_36px_rgba(0,85,255,0.45)] hover:shadow-[0_18px_48px_rgba(0,85,255,0.55)] hover:-translate-y-0.5 active:scale-[0.98] transition-[box-shadow,transform] duration-300"
            >
              Deyem for Business
              <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="space-y-3" data-testid="business-connections">
            {LINKS.map(([a, b], i) => (
              <div key={a} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-4 backdrop-blur hover:bg-white/[0.07] transition-colors duration-300">
                <span className="font-display text-lg font-medium tracking-tight text-white">{a}</span>
                <span className="flex-1 relative h-px bg-white/15">
                  <span className="absolute inset-0 bg-gradient-to-r from-diem-blue to-diem-sky origin-left animate-[grow_1.4s_ease_forwards]" style={{ animationDelay: `${i * 0.15}s` }} />
                  <svg className="absolute right-0 -top-[5px] w-3 h-3 text-diem-sky" viewBox="0 0 12 12" fill="currentColor"><path d="M2 1l9 5-9 5V1z" /></svg>
                </span>
                <span className="font-display text-lg font-medium tracking-tight text-diem-sky">{b}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
